import { isEnum } from "class-validator"

/**
 *  A function to parse a specific value as an enum with passing a valid enum
 *  value as callback. This function is useful when we store an enum value in
 *  a storage mechanism that doesn't support our typing and then we need to
 *  retrieve it.
 */
export function parseEnum<TEnum extends object>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  input: any,
  suspect: TEnum,
  fallback: TEnum[keyof TEnum]
): TEnum[keyof TEnum] {
  if (isEnum(input, suspect)) {
    return input
  }

  return fallback
}
